
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import GTag from '../components/GTag';
function Punetoajantaellorapackage() {



    const cardData =
    {
        keyword: 'Pune to Ajanta Ellora Tour Package ',
        heading: 'Mauli Cabs: Pune to Ajanta Ellora Tour Package ',
        headingDescription: 'Mauli Cabs offers convenient and affordable Pune to Ajanta Ellora Tour Package, ensuring a smooth and comfortable journey to the spiritual town of Shirdi. Whether you are planning a one-day trip or a longer stay, our packages include a range of vehicles like sedans, SUVs, and premium cars to suit your preferences. With professional drivers, transparent pricing, no hidden charges, and a focus on customer satisfaction, Mauli Cabs guarantees a hassle-free and memorable ride to Shirdi, providing you with the best value for your journey.',

        top: 'Top Places to Visit in Ajanta Ellora with Mauli Cabs',

"topPlaces": [
    {
        "title": "Ajanta Caves",
        "description": "Ajanta Caves are a group of 30 rock-cut Buddhist cave temples known for their exquisite ancient murals and sculptures. The caves date back to the 2nd century BCE to 6th century CE and are a UNESCO World Heritage site, attracting history and art enthusiasts from all over the world."
    },
    {
        "title": "Ellora Caves",
        "description": "Ellora Caves are a complex of 34 monasteries and temples, including Hindu, Buddhist, and Jain cave temples. The Kailasa Temple, a single monolithic structure, is one of the most impressive architectural feats in the world."
    },
    {
        "title": "Kailasa Temple (Ellora)",
        "description": "The Kailasa Temple at Ellora is a remarkable monolithic structure, carved from a single rock, and is dedicated to Lord Shiva. The intricate carvings and sculptures make it one of the most magnificent temples in India."
    },
    {
        "title": "Buddhist Caves (Ajanta)",
        "description": "The Buddhist caves at Ajanta are known for their stunning frescoes and paintings that depict the life of the Buddha. These caves offer a glimpse into the spiritual and artistic heritage of ancient India."
    },
    {
        "title": "Saptashrungi",
        "description": "Saptashrungi is a hilltop temple dedicated to Goddess Saptashrungi, located near the Ajanta caves. It offers a blend of spiritual significance and scenic beauty, with panoramic views from the top."
    },
    {
        "title": "Jain Caves (Ellora)",
        "description": "The Jain Caves at Ellora are dedicated to the Jain religion and feature beautiful carvings and sculptures depicting Jain Tirthankaras. These caves are relatively less crowded but offer impressive architecture."
    },
    {
        "title": "Aurangabad Caves",
        "description": "The Aurangabad Caves are a group of 12 rock-cut Buddhist caves, located near the city of Aurangabad. They are known for their intricate carvings and sculptures and are often less crowded than Ajanta and Ellora."
    },
    {
        "title": "Daulatabad Fort",
        "description": "Located about 15 km from Ellora, Daulatabad Fort is a historic fort known for its impressive architecture, including its strong defenses and the climb to the top. It offers spectacular views of the surrounding area."
    },
    {
        "title": "Grishneshwar Temple",
        "description": "Grishneshwar Temple is one of the 12 Jyotirlingas of Lord Shiva, located near Ellora. This temple is a significant pilgrimage site for devotees of Lord Shiva and is known for its spiritual importance."
    },
    {
        "title": "Ajanta Viewpoint",
        "description": "The Ajanta Viewpoint offers a scenic view of the Ajanta Caves from a distance, allowing visitors to take in the beauty of the caves and the surrounding landscape. It’s a great spot for photography."
    }
],

"services": [
    {
      "name": "Pune to Ajanta Ellora Caves Cab Booking",
      "description": "Book a comfortable and reliable cab for your journey from Pune to the world-famous Ajanta and Ellora Caves, ensuring a smooth and scenic ride."
    },
    {
      "name": "Pune to Ajanta Ellora Tour Package Cost",
      "description": "Check out the affordable tour package cost for your trip from Pune to Ajanta and Ellora Caves. The package includes transportation, guide, and sightseeing."
    },
    {
      "name": "Pune to Sambhaji Nagar Cab",
      "description": "Book a reliable cab from Pune to Sambhaji Nagar (Aurangabad) for a comfortable ride with a professional driver."
    },
    {
      "name": "Pune to Aurangabad Car Service",
      "description": "Enjoy a seamless and convenient car service from Pune to Aurangabad, available in various vehicle options depending on your preference and group size."
    },
    {
      "name": "Pune to Shirdi and Shani Shingnapur Cab",
      "description": "Book a cab for a spiritual journey to Shirdi and Shani Shingnapur from Pune. Visit the revered temples with a comfortable ride."
    },
    {
      "name": "Pune to Grishneshwar Cab Service",
      "description": "Book a cab for your visit to Grishneshwar, one of the 12 Jyotirlingas, with smooth and comfortable transport from Pune."
    },
    {
      "name": "Pune to Shani Shingnapur Cab",
      "description": "Book a convenient cab from Pune to Shani Shingnapur for a smooth and reliable journey to the famous Shani temple."
    },
    {
      "name": "Pune to Shani Shingnapur Cab Fare",
      "description": "Check the fare details for a cab from Pune to Shani Shingnapur. Our pricing is affordable and offers various vehicle options."
    },
    {
      "name": "Pune to Paithan Cab Service",
      "description": "Book a comfortable and affordable cab service for your trip from Pune to Paithan, a historic town known for its temples and ancient culture."
    },
    {
      "name": "Pune to Shegaon Cab Booking",
      "description": "Book a taxi for a smooth journey from Pune to Shegaon, home to the famous Gajanan Maharaj temple."
    },
    {
      "name": "Pune to Shegaon Cab Service",
      "description": "We offer reliable cab services from Pune to Shegaon for your convenience and comfort during your journey to the temple town."
    },
    {
      "name": "Pune to Shegaon Cab Service Cost",
      "description": "Find affordable pricing for cab services from Pune to Shegaon. We offer transparent pricing with no hidden charges."
    },
    {
      "name": "Pune to Aurangabad Cab",
      "description": "Book a cab from Pune to Aurangabad for a comfortable and efficient ride to this historic city."
    },
    {
      "name": "Pune to 5 Jyotirlinga Darshan Cab",
      "description": "Embark on a spiritual journey with our 5 Jyotirlinga Darshan cab service, visiting the 5 sacred Jyotirlingas from Pune, with a smooth and convenient ride."
    },
    {
      "name": "Pune to Ahmednagar Cabs",
      "description": "Book a reliable cab from Pune to Ahmednagar, a city known for its historic landmarks and temples, ensuring a comfortable travel experience."
    },
    {
      "name": "Pune to Ahilya Nagar Cabs",
      "description": "Travel to Ahilya Nagar with ease by booking a cab from Pune. Experience a smooth and comfortable ride to this historical and cultural city."
    },
    {
      "name": "Pune to Shrirampur Cab",
      "description": "Book a cab for your trip from Pune to Shrirampur, offering a smooth and hassle-free journey with professional drivers."
    }
  ],
  "tableData": [
    ["Pune to Ajanta Ellora Caves Cab Booking", "Pune to Ajanta Ellora Tour Package Cost"],
    ["Pune to Sambhaji Nagar Cab", "Pune to Aurangabad Car Service"],
    ["Pune to Shirdi and Shani Shingnapur Cab", "Pune to Grishneshwar Cab Service"],
    ["Pune to Shani Shingnapur Cab", "Pune to Shani Shingnapur Cab Fare"],
    ["Pune to Paithan Cab Service", "Pune to Shegaon Cab Booking"],
    ["Pune to Shegaon Cab Service", "Pune to Shegaon Cab Service Cost"],
    ["Pune to Aurangabad Cab", "Pune to 5 Jyotirlinga Darshan Cab"],
    ["Pune to Ahmednagar Cabs", "Pune to Ahilya Nagar Cabs"],
    ["Pune to Shrirampur Cab", ""]
  ],


"whychoose": [
    {
        "WhyChooseheading": "Reliable and Timely Service",
        "WhyChoosedescription": "Mauli Cabs offers reliable and timely service for your Pune to Ajanta Ellora tour. Our professional drivers ensure that you arrive on time and in comfort, allowing you to focus on enjoying the historical sites without worrying about your transport."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles",
        "WhyChoosedescription": "For your Pune to Ajanta Ellora journey, we provide a variety of comfortable and spacious vehicles. Whether you prefer a sedan, SUV, or premium car, all our vehicles are air-conditioned and well-maintained to ensure a relaxing and comfortable experience."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our experienced drivers are well-acquainted with the Pune to Ajanta Ellora route. They ensure a smooth and safe journey, navigating the best roads and providing you with a hassle-free ride to these UNESCO World Heritage sites."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Mauli Cabs offers competitive and transparent pricing for your Pune to Ajanta Ellora tour package. With no hidden charges, we provide upfront pricing to give you the best value for your money while ensuring a comfortable trip."
    },
    {
        "WhyChooseheading": "Safe and Comfortable Journey",
        "WhyChoosedescription": "Your safety is our top priority. All our vehicles are equipped with modern safety features, including airbags, seat belts, and GPS tracking. Our drivers follow strict safety protocols to ensure a secure and comfortable ride throughout your journey."
    },
    {
        "WhyChooseheading": "24/7 Availability",
        "WhyChoosedescription": "Mauli Cabs is available 24/7 for your Pune to Ajanta Ellora tour. Whether you want to depart early in the morning or return late at night, our customer service team is always available to assist with your booking at any time."
    },
    {
        "WhyChooseheading": "Easy and Hassle-Free Booking",
        "WhyChoosedescription": "Booking your Pune to Ajanta Ellora tour package with Mauli Cabs is quick and hassle-free. You can book online through our website or mobile app, or reach out to our customer service team for personalized assistance, ensuring a smooth booking experience."
    },
    {
        "WhyChooseheading": "Customized Travel Packages",
        "WhyChoosedescription": "Mauli Cabs offers customized travel packages for your Pune to Ajanta Ellora tour. Whether you're traveling with family, friends, or a group, we can tailor the package to suit your specific preferences, providing a unique and memorable tour experience."
    }
]

















    }


    const faqData = [
        {
            question: 'How do I book a cab for the Pune to Ajanta Ellora tour with Mauli Cabs?',
            answer: 'Booking a cab for the Pune to Ajanta Ellora tour with Mauli Cabs is simple! You can book directly through our website or mobile app by entering your pickup location (Pune) and destination (Ajanta Ellora), choosing the type of vehicle, and confirming the booking. Alternatively, you can contact our customer support team for assistance.',
        },
        {
            question: 'What types of cabs are available for the Pune to Ajanta Ellora tour?',
            answer: 'Mauli Cabs offers a range of vehicles for the Pune to Ajanta Ellora tour, including Sedans, SUVs, Ertiga, Innova Crysta, and premium options. Depending on your preferences, you can select a vehicle that ensures comfort and convenience for your trip.',
        },
        {
            question: 'Is the fare for the Pune to Ajanta Ellora tour fixed?',
            answer: 'Yes, the fare for the Pune to Ajanta Ellora tour is fixed and transparent. The fare includes tolls, taxes, driver charges, and other fees with no hidden costs. You will be provided with the total fare upfront when confirming the booking.',
        },
        {
            question: 'Can I book a round trip for the Pune to Ajanta Ellora tour?',
            answer: 'Yes, you can easily book a round trip for the Pune to Ajanta Ellora tour. Just provide your return details while making the booking, and we’ll ensure a comfortable and timely return journey as well.',
        },
        {
            question: 'How long does the journey from Pune to Ajanta Ellora take?',
            answer: 'The journey from Pune to Ajanta Ellora typically takes around 5 to 6 hours, depending on traffic and road conditions. Our experienced drivers know the best routes to ensure a smooth and timely ride.',
        },
        {
            question: 'Are the drivers experienced for the Pune to Ajanta Ellora route?',
            answer: 'Yes, all Mauli Cabs drivers are well-trained, experienced, and familiar with the routes to Ajanta Ellora. They ensure that your journey is safe, comfortable, and efficient.',
        },
        {
            question: 'Can I make stops during my journey from Pune to Ajanta Ellora?',
            answer: 'Yes, you can make stops along the way for breaks, sightseeing, or meals. Our drivers will be happy to accommodate any requests and ensure that your trip is as enjoyable as possible.',
        },
        {
            question: 'Are the cabs air-conditioned and well-maintained for the Pune to Ajanta Ellora tour?',
            answer: 'Yes, all our cabs for the Pune to Ajanta Ellora tour are air-conditioned and regularly maintained for cleanliness and comfort. We ensure a pleasant and relaxing ride throughout the journey.',
        },
        {
            question: 'Can I cancel or modify my booking for the Pune to Ajanta Ellora tour?',
            answer: 'Yes, you can easily cancel or modify your booking for the Pune to Ajanta Ellora tour. We offer a flexible cancellation and modification policy through our website or app, and our customer support team is available to assist you anytime.',
        },
        {
            question: 'Why should I choose Mauli Cabs for my Pune to Ajanta Ellora tour?',
            answer: 'Mauli Cabs offers competitive pricing, a wide range of vehicles, professional drivers, and a commitment to ensuring a comfortable and timely journey. Whether you’re visiting Ajanta Ellora for historical exploration or leisure, we ensure a hassle-free and enjoyable trip.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Sanjay Patel",
            position: "History Enthusiast",
            text: "I took the Pune to Ajanta Ellora tour with Mauli Cabs, and it was an amazing experience. The car was comfortable, the driver was knowledgeable, and the entire trip was smooth. The Ajanta Ellora caves were breathtaking, and the journey was stress-free. Highly recommend Mauli Cabs!",
            image: "/img/testimonial/testimonial-thumb-1-1.png",
        },
        {
            name: "Miss. Aarti Mehta",
            position: "Tourist",
            text: "My journey from Pune to Ajanta Ellora with Mauli Cabs was incredible. The driver was friendly and professional, and the car was well-maintained. The tour itself was memorable, and the comfort of the ride made it all the more enjoyable. I’ll definitely book with Mauli Cabs again!",
            image: "/img/testimonial/testimonial-thumb-1-2.png",
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    









    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7972733209",
            "+91 9763272775",

        ],
        email: "booking@maulicabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Car Rental",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Shirdi Cab Booking",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mahabaleshwar Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala - Khandala Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mumbai Airport Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Pune to Adlabs Imagica Cab Booking ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Best Cab Service For Matheran",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Ganpatipule Cab Booking",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Pandharpur Cab Booking",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Jyotirlinga Tour Package",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Ashtavinayak Darshan Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Best Cab From Pune to Murud Janjira",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Alibaug Affordable Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Ajanta Ellora Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Aurangabad Cab Booking",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Pune to Sade Teen Shakti Peeth Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Bhimashankar Round Trip",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Trimbakeshwar Best Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Nashik and Igatpuri Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Kolhapur Cab Booking",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Satara Cab Booking",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Tarkarli - Malvan Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Outstation Cab",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Goa Cab Booking",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Tuljapur Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Alandi - Dehu Darshan Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   
    const jsonData = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Pune to Ajanta Ellora Tour Package by Mauli Cabs",
        "description": "Mauli Cabs offers a curated Pune to Ajanta Ellora tour package, including visits to the Ajanta Caves, Ellora Caves, Grishneshwar, and other nearby attractions. Choose from affordable cab options for a comfortable and memorable trip from Pune to Aurangabad and beyond.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.7",
          "ratingCount": "4100"
        }
      };
      

      

    return (
        <div>
            <GTag/>

<Helmet>
        <title>Pune to Ajanta Ellora Tour Package | Mauli Cabs | Call +91 7972733209</title>
        <meta
          name="description"
          content="Book your Pune to Ajanta Ellora tour package with Mauli Cabs. Visit Ajanta and Ellora Caves, Grishneshwar, and other nearby attractions with our affordable and reliable cab service from Pune to Aurangabad. Enjoy a comfortable and guided tour."
        />
        <meta
          name="keywords"
          content="Pune to Ajanta Ellora Caves Cab Booking, Pune to Ajanta Ellora Tour Package Cost, Pune to Sambhaji Nagar Cab, Pune to Aurangabad Car Service, Pune to Shirdi and Shani Shingnapur Cab, Pune to Grishneshwar Cab Service, Pune to Shani Shingnapur Cab, Pune to Shani Shingnapur Cab Fare, Pune to Paithan Cab Service, Pune to Shegaon Cab Booking, Pune to Shegaon Cab Service, Pune to Shegaon Cab Service Cost, Pune to Aurangabad Cab, Pune to 5 Jyotirlinga Darshan Cab, Pune to Ahmednagar Cabs, Pune to Ahilya Nagar Cabs, Pune to Shrirampur Cab"
        />
        <script type="application/ld+json">
          {JSON.stringify(jsonData)}
        </script>
      </Helmet>


            <section
                className="vs-breadcrumb"
                style={{ backgroundImage: 'url(/img/bg/breadcrumb-bg-2.png)' }}
            >
                <div className="container">
                    <div className="row text-center">
                        <div className="col-12">
                            <div className="breadcrumb-content">
                                <h1 className="breadcrumb-title">{cardData.keyword}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/40.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mauli Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #631D02',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#631D02' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917972733209" className="d-block  text-white">+91 7972733209</a>
                                                <a href="tel:+919763272775" className="d-block  text-white">+91 9763272775</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:booking@maulicabs.com" className=" text-white d-block">
                                                    booking@maulicabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Mauli Cabs <br />
                                                    Pune Alandi Road , Wadmukkhwadi Charholi Bk, Alandi Devachi , Khed , Pune 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetoajantaellorapackage;